<template>
  <section id="testimonial" class="n2-seccion n4-testimonios" v-if="NOTARIA?.Theme?.Home?.Testimonios?.Mostrar && lista.length">
    <div class="n2-contenedor">
      <div class="n4-cabeza n2-aparece">
        <span class="n4-cabeza__num" aria-hidden="true">{{ numero('testimonial') }}</span>
        <h2 class="n4-titular">{{ tSolicitud('Opiniones') }}</h2>
      </div>
      <!-- Página en negativo con las citas en columnas, como cartas al director -->
      <div class="n4-cartas" :class="{ 'n4-cartas--muchas': lista.length > 2 }">
        <figure v-for="(t, i) in lista" :key="i" class="n4-carta n2-aparece">
          <div class="n2-estrellas" :aria-label="(Number(t.Estrellas) || 5) + ' / 5'">
            <v-icon v-for="n in (Number(t.Estrellas) || 5)" :key="n" size="16">{{ NOTARIA.Theme.Home.Testimonios.Icon || 'mdi-star' }}</v-icon>
          </div>
          <blockquote>{{ textoPlano(t.Descripcion) }}</blockquote>
          <figcaption>
            <img v-if="t.Imagen" :src="imagenIDtoSRC(t.Imagen)" :alt="t.Nombre" loading="lazy" />
            <span>{{ t.Nombre }}</span>
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { textoPlano } from '../../composables/useNotaria2'
import { useSumario } from '../../composables/useNotaria4'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC } = useUtils()
const { numero } = useSumario()
// Panel: Testimonios (y su interruptor en Inicio)
const lista = computed(() => NOTARIA.value?.Testimonios ?? [])
</script>
